// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__KATVB","label":"Labeled_label__38Id8","divider":"Labeled_divider__19jOw"};